// extracted by mini-css-extract-plugin
export default {"allReport":"allReport_allReport__3W6Hq","noData":"allReport_noData__5MU3e"};